<div class="component-wrapper">
<form [formGroup]="contactDataForm">
<kontakt-new class="vertretungsberechtigter-input" [form]="contactDataForm.Vertretungsberechtigter"
    kontakttyp="vertretungsberechtigter" ></kontakt-new>

    <div class="mt-4">
        <kendo-formfield class="cbweitererVertretungsberechtigter">
            <div class="k-checkbox-wrap">
                <input id="cbweitererVertretungsberechtigter" #cbweitererVertretungsberechtigter type="checkbox" kendoCheckBox
                    formControlName="cbweitererVertretungsberechtigter" />
                <label id="cbweitererVertretungsberechtigter" for="cbweitererVertretungsberechtigter"
                    class="k-checkbox-label vertretungsberechtigter3-heading" translate>
                    contact-data.additionalAuthorizedRepresentative
                </label>
            </div>
        </kendo-formfield>
        <div *ngIf="cbweitererVertretungsberechtigter.checked" class="vertretungsberechtigter2 mt-3">
            <kontakt-new class="vertretungsberechtigter2-input" [form]="contactDataForm.WeitererVertretungsberechtigter"
                kontakttyp="weitererVertretungsberechtigter" ></kontakt-new>
        </div>
    </div>
</form>